import React from "react";
import {
  Button,
  Label,
  Input,
  FormGroup,
  Form,
  Modal,
  FormFeedback,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Tooltip,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import API from "../../../redux/actions/API";
import { LICENSE_CATEGORY } from "../../../constants/ApiPaths";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import { useState } from "react";
import CustomButtonLoader from "../../CustomComponents/CustomButtonLoader";
import { Info } from "../../common/Info";
import { authHeader } from "../../../functions/CoreFunctions";

export default function Createnewcategory(props) {
  const [loading, setLoading] = useState(false);

  const {
    toggle,
    modal,
    CategoryDetails,
    categoryForm,
    GetLicensePlan,
    UpdateToogle,
    templateId,
    GetLicense,
  } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };

  const validationSchema = Yup.object().shape({
    categoryName: Yup.string().required("Category Name Required"),
  });

  const {
    handleSubmit,
    handleChange,
    values,
    handleBlur,
    errors,
    touched,
    resetForm,
  } = useFormik({
    initialValues: categoryForm,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => CreateCategory(values),
  });

  let CreateCategory = async () => {
    setLoading(true);
    const config = {
      method: "POST",
      headers: authHeader(),

      url: LICENSE_CATEGORY,
      data: {
        licenseCategoryDetails: UpdateToogle
          ? values
          : { ...values, categoryOrder: CategoryDetails.length + 1 },
        templateId: templateId,
      },
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      console.log(response, "RESPONSE");
      if (status === "Success") {
        toggle();
        GetLicense();
        CustomAlertMessage(
          UpdateToogle
            ? "Category Details Updated Sucessfully"
            : "Category Added Sucessfully",
          "success",
          enqueueSnackbar
        );
        resetForm();
        setLoading(false);
        GetLicensePlan();
      }
    } catch (error) {
     
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      size="md"
      centered={true}
      isOpen={modal}
      toggle={() => toggle(resetForm({}))}
    >
      <Form form="true" onSubmit={handleSubmit}>
        <ModalHeader toggle={toggle}>
          {UpdateToogle ? (
            <>
              Update Category{" "}
              <Tooltip
                isOpen={id === "updatecategory" && tooltipOpen}
                target={"updatecategory"}
                toggle={() => tooltiptoggle("updatecategory")}
              >
                Update Category
              </Tooltip>
              <span id={"updatecategory"}>
                <Info />
              </span>
            </>
          ) : (
            <>
              Create Category{" "}
              <Tooltip
                isOpen={id === "createcategory" && tooltipOpen}
                target={"createcategory"}
                toggle={() => tooltiptoggle("createcategory")}
              >
                Create Category
              </Tooltip>
              <span id={"createcategory"}>
                <Info />
              </span>
            </>
          )}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="">Category Name</Label>

            <Input
              type="text"
              name="categoryName"
              value={values.categoryName}
              onBlur={handleBlur}
              placeholder="Enter Category Name"
              invalid={
                errors.categoryName && touched.categoryName ? true : false
              }
              onChange={handleChange}
            />
            <FormFeedback>{errors.categoryName}</FormFeedback>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit">
            {loading && <CustomButtonLoader />}Submit
          </Button>

          <Button color="danger" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}
